export const toShopDomain = (shop: string): string => shop 
  ? shop.includes('.myshopify.com') 
    ? shop 
    : `${shop}.myshopify.com`
  : '';

export const toShopDomainName = (shop: string): string => {
  return shop.replace('.myshopify.com', '');
};
